var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcNotificationIconNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5615 18.9822C12.7845 19.746 12.695 20.567 12.3126 21.2648C11.9302 21.9625 11.2863 22.4798 10.5225 22.7028C9.75878 22.9258 8.93771 22.8362 8.23997 22.4538C7.54223 22.0714 7.02497 21.4275 6.80198 20.6638M7.90261 5.43632L7.46459 5.54938C4.25236 6.4789 2.22718 9.90061 3.12744 13.0662L4.18963 16.7043C4.41104 17.4626 4.53113 18.2307 4.30153 18.9822L4.14879 19.4831C3.9154 20.2429 4.616 20.9656 5.36954 20.7456L17.8672 17.1084C18.6207 16.8884 18.8215 15.9026 18.2169 15.3874L17.8186 15.0474C17.2217 14.5373 16.9084 13.8245 16.687 13.0662L15.6254 9.42998C14.6644 6.28112 11.1148 4.50681 7.90261 5.43632Z",
    stroke: "#002E6C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53694 2.09661L6.24414 5.64859L8.70494 4.79745L7.34657 1.97126C6.99788 1.24981 6.02686 1.58321 5.35792 1.81439L4.53694 2.09661Z",
    fill: "#002E6C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotificationIconNew);
export default __webpack_public_path__ + "static/media/ic_notification_icon_new.19c0a0a1e1e76d9ea9df939988e0f696.svg";
export { ForwardRef as ReactComponent };